import mitt from "mitt"
export default mitt<{ [k: string]: any }>()
